<template>

    <div class="form-group">
        <label v-if="hideLabel === false" for="">{{ element.display_name }}</label>
        <select class="form-control" v-model="element.value" @input="handleInput">
            <option :value="null" disabled hidden>{{ t.__('Wybierz...') }}</option>
            <option :value="undefined" disabled hidden>{{ t.__('Wybierz...') }}</option>
            <option v-for="choice in element.choices" :value="choice.value">{{ choice.display_name }}</option>
        </select>
        <div class="d-block invalid-feedback" v-if="error">{{ error }}</div>
    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameEditorChoice',

    props: {
        value: Object,
        location: String,
        hideLabel: Boolean
    },

    data() {
        return {
            eventHub: window.eventHub,
            element: this.value,
            error: null
        }
    },

    computed: {
        elementLocation() {
            if (this.location) {
                return this.location + '.' + this.element.name;
            }
            return this.element.name
        }
    },

    mounted() {
        this.eventHub.$on('personalized-games-update-errors', errors => {
           if (errors[this.elementLocation] !== undefined) {
               this.error = errors[this.elementLocation];
           } else {
               this.error = null;
           }
        });
    },

    methods: {
        handleInput (e) {
            this.$emit('input', this.element)
        }
    }

}
</script>

<style scoped>

</style>
